import { AppsService } from '../../services/apps.service';
import { ColegiosService } from '../../services/colegios.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { App } from '../../interfaces/app';
import { ChatService } from './../../services/chat.service';
import { UserService } from './../../services/user.service';
import { createEvent, download } from './event-download.utils';
import { EventosService } from './../../services/eventos.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';

import { AngularFireFunctions } from '@angular/fire/functions';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class DashboardHomeComponent implements OnInit {
  userdata: any;
  colegio: any;
  app: App;
  colegioapps_internas = [];
  colegioapps_externas = [];
  mainuseremail: any;
  userUid: any;
  nombres: any;
  apellidos: any;
  chats = [] as any;
  receiveruserchat: any;
  chatusers = [];
  grupodechats = [];
  events = [];
  content: any = '';
  eventos = [];
  locals: any;
  pexipdata: any;
  camaras: any = [];
  micros: any[];
  audios: any[];
  n: number = 0;
  apagado: boolean = false;
  deviceId: any;
  results: any = '';
  clases: any;
  searchValue = '';
  usuario: any;
  cargado: boolean = false;
  conteomensajes: number;

  profesoresPop: boolean = false;

  clasesCapadas = [
    '0MYFZ2lrZKZ69JjARsVB',
    '0MYFrkjV4l2THtX6CLGZ',
    '000LlElEx00000000',
    '000LlElEx00000001',
    '000LlElEx00000002',
    '000LlElEx00000003',
    '000LlElEx00000004',
    '000LlElEx00000005',
    '000LlElEx00000006',
    '000LlElEx00000007',
    '000LlElEx00000008',
    '000LlElEx00000009',
    '000LlElEx00000010',
    '000LlElEx00000011',
    '000LlElEx00000012',
    '000LlElEx00000013',
    '000LlElEx00000014',
    '000LlElEx00000015',
    '000LlElEx00000016',
    '000LlElEx00000017',
    '000LlElEx00000018',
  ];

  searchApp = '';
  selectedCategory = 'todas';
  appCategories = [
    { nombre: 'Todas', categoria: 'todas' },
    { nombre: 'Académico', categoria: 'academico' },
    { nombre: 'Google', categoria: 'google' },
    { nombre: 'Musica', categoria: 'musica' },
    { nombre: 'Video', categoria: 'video' },
    { nombre: 'Otros', categoria: 'otros' },
  ];
  id = '';

  loading = false;

  constructor(
    private authenticationService: AuthenticationService,
    private colegioService: ColegiosService,
    private appsService: AppsService,
    private chatService: ChatService,
    private userService: UserService,
    private breadService: BreadcrumbService,
    private http: HttpClient,
    private eventosService: EventosService,
    private functions: AngularFireFunctions,
    private notificacionesService: NotificacionesService
  ) {}

  private getUserRole(user: any): string {
    return user?.role || user?.role || '';
  }

  private getUserName(user: any): string {
    return user?.name || user?.nombres || '';
  }

  private getUserLastName(user: any): string {
    return user?.last_name || user?.apellidos || '';
  }

  private getUsername(user: any): string {
    return user?.username || user?.usuario || user?.email || '';
  }

  private getClassIds(user: any): string[] {
    return user?.classes || user?.clases || [];
  }

  private getSchoolIds(user: any): string[] {
    return user?.schools || user?.colegios || [];
  }

  isColegiaSchool(user: any): boolean {
    return this.getSchoolIds(user)[0] === 'uPXS5qpSkgA3aHH80QYn';
  }

  ngOnInit(): void {
    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.getmainuserdata();
    } else {
      this.userUid = Userdata.payload.doc.data().uid; /* id del usuario */
      this.id = Userdata.payload.doc.id; /* id del usuario */
      this.mainuseremail =
        Userdata.payload.doc.data().email; /* email del usuario */
        this.getUserRole(Userdata.payload.doc.data()) != 'student' &&
        this.getUserRole(Userdata.payload.doc.data()) != 'student'
          ? (this.profesoresPop = true)
          : (this.profesoresPop = false);
      this.usuario = this.getUsername(Userdata.payload.doc.data());
      this.getroom(this.usuario);

      this.userdata = Userdata.payload.doc.data();
      this.clases = this.getClassIds(this.userdata);
      this.nombres = this.getUserName(this.userdata); /* nombres del usuario logueado */
      this.apellidos = this.getUserLastName(this.userdata); /*apellidos del usuario logueado */

      this.notificacionesService
        .getNotificacionesMensajes(this.userUid)
        .subscribe((notificaciones) => {
          this.conteomensajes = 0;
          if (notificaciones.length > 0) {
            this.conteomensajes = notificaciones.length;
          }
        });

      this.getApps(
        this.userdata
      ); /* llama a la funcion para obtener las apps del colegio */
      this.getLastChats(this.userUid); /* obtiene los ultimos mensajes */
    }
    this.camaras = new Array();
    var id = localStorage.getItem('deviceId');
    var apagado = localStorage.getItem('apagado');
    if (apagado == 'true') {
      this.apagado = true;
      this.videoMedias();
    } else {
      if (id) {
        this.videoMedias().then(() => {
          this.selectAvailableCamera(id);
        });
      } else {
        this.videoMedias().then(() => {
          this.selectAvailableCamera();
        });
      }
    }
  }

  cambiarNdeCamara(id) {
    for (let index = 0; index < this.camaras.length; index++) {
      if (id == this.camaras[index].deviceId) {
        this.n = index;
      }
    }
  }

  /* trae informacion principal del usuario logueado */
  getmainuserdata() {
    this.authenticationService.isAuth().subscribe((auth) => {
      if (auth) {
        this.userUid = auth.uid; /* id del usuario */
        this.mainuseremail = auth.email; /* email del usuario */

        this.userService
          .getUserById(this.userUid)
          .subscribe((userdata: any) => {
            if (userdata.length > 0) {
              this.id = userdata[0].payload.doc.id; /* id del usuario */
              this.userdata = userdata[0].payload.doc.data();
              this.getUserRole(this.userdata) != 'student' &&
              this.getUserRole(this.userdata) != 'student'
                ? (this.profesoresPop = true)
                : (this.profesoresPop = false);
              this.nombres = this.getUserName(this.userdata); /* nombres del usuario logueado */
              this.usuario = this.getUsername(this.userdata);
              this.apellidos = this.getUserLastName(this.userdata); /*apellidos del usuario logueado */
              this.clases = this.getClassIds(this.userdata);
              this.getroom(this.usuario);
              this.getApps(
                this.userdata
              ); /* llama a la funcion para obtener las apps del colegio */
              this.getLastChats(
                this.userUid
              ); /* obtiene los ultimos mensajes */
            }
          });
        // this.authenticationService
        //   .isUserAdmin(this.userUid)
        //   .subscribe((userdata) => {
        //     if (userdata[0]) {
        //       this.userdata = userdata[0];

        //     }
        //   });

        this.notificacionesService
          .getNotificacionesMensajes(this.userUid)
          .subscribe((notificaciones) => {
            this.conteomensajes = 0;
            if (notificaciones.length > 0) {
              this.conteomensajes = notificaciones.length;
            }
          });
      }
    });
  }

  /* obtiene las app del primer colegio(array) al que pertenezca el usuario logueado */
  getApps(userdata) {
    const schoolIds = this.getSchoolIds(userdata);
    if (userdata && schoolIds[0]) {
      this.colegioService
        .getColegioById(schoolIds[0])
        .subscribe((colegio) => {
          if (colegio) {
            this.colegio = colegio.payload.data();

            this.colegioapps_internas = [];
            this.colegioapps_externas = [];

            if (this.colegio.apps) {
              this.colegio.apps.forEach((app: any) => {
                this.appsService.getAppById(app).subscribe((app) => {
                  const appData = app?.payload?.data();
                  if (appData) {
                    this.app = {
                      icono: appData.icon || appData.icono,
                      nombre: appData.name || appData.nombre,
                      url: appData.url,
                      tipo:
                        appData.internal === true
                          ? 'interna'
                          : appData.internal === false
                          ? 'externa'
                          : appData.tipo,
                      categoria: appData.category || appData.categoria,
                    } as any;
                    this.cargado = true;

                    if (this.app.tipo === 'interna') {
                      if (
                        !this.colegioapps_internas.some(
                          (el) => el.nombre === this.app.nombre
                        )
                      ) {
                        /* añade las apps internas a un array */
                        this.colegioapps_internas.push({
                          icono: this.app.icono,
                          nombre: this.app.nombre,
                          url: this.app.url,
                        });
                      }
                    } else {
                      if (
                        !this.colegioapps_externas.some(
                          (el) => el.nombre === this.app.nombre
                        )
                      ) {
                        /* añade las apps externas un array */
                        this.colegioapps_externas.push({
                          icono: this.app.icono,
                          nombre: this.app.nombre,
                          url: this.app.url,
                          categoria: this.app.categoria,
                        });
                      }
                    }
                  } else {
                    this.cargado = true;
                  }
                });
              });
            } else {
              this.cargado = true;
            }
          } else {
            this.cargado = true;
          }
        });
    } else {
      this.cargado = true;
    }
  }

  /* obtiene los ultimos mensajes de chat */
  getLastChats(mainuserid) {
    this.chatService.getChats(mainuserid).subscribe((chat) => {
      chat.forEach((chatData: any) => {
        /* genera la id del chat */
        const messagechatid = [
          chatData.members[0].uid,
          chatData.members[1].uid,
        ].sort();
        const themeschaid = messagechatid.join('|');

        /* encuentra el usuario receptor o emisor que es el que no tiene la id del usuario logueado */
        let receiveruser;
        if (chatData.members[1].uid != mainuserid) {
          receiveruser = chatData.members[1].uid;
        } else {
          receiveruser = chatData.members[0].uid;
        }

        /* trae la informacion el usuario receptor o emisor */
        this.userService.getUserById(receiveruser).subscribe((user) => {
          if (user.length > 0) {
            this.receiveruserchat = user[0].payload.doc.data();
            /* guarda la informacion del usuario en un array usando su id como clave */
            this.chatusers[this.receiveruserchat.uid] =
              user[0].payload.doc.data();
            this.chats = chat; /* guarda todos los chats abiertos */
            this.getLastMessage(themeschaid, mainuserid);
          }
        });
      });
    });
  }

  getLastMessage(chatid, mainuserid) {
    this.chatService.getLastMessage(chatid, mainuserid).subscribe((chat) => {
      if (chat[0]) {
        this.grupodechats[chatid] = chat[0].payload.doc.data();
      }
    });
  }

  /* funcion para descargar ics de eventos */
  download() {
    var click = true; //si el usuario cliquea en download comienza la función, y no se ve afectada la suscripcion de modificación del evento.

    /* añade todos los eventos al array para luego generar el archivo ics */
    this.eventosService
      .getEventosByUseridOrdenado(this.userUid)
      .subscribe((eventosdata) => {
        if (eventosdata !== undefined) {
          this.eventos = eventosdata;
          this.eventos.forEach((evento) => {
            this.events.push({
              start: evento.payload.doc
                .data()
                .fecha_inicio.toDate() /*fecha de inicio*/,
              end: evento.payload.doc
                .data()
                .fecha_final.toDate() /* fecha final */,
              summary: evento.payload.doc.data().name /* resumen */,
              description:
                evento.payload.doc.data().description /*descripción */,
            });
          });
          this.content = createEvent(this.events);
          if (click) {
            download(
              'thecampus-calendar.ics',
              this.content
            ); /* genera archivo */
            click = false;
          }
        }
      });
  }

  UpdateBreadcrumb(name, url) {
    this.breadService.addtobread(name, url);
  }

  getroom(usuario) {
    this.http
      .get<any>(
        'https://us-central1-the-campus-56b06.cloudfunctions.net/getRoom',
        { params: new HttpParams().set('salaname', usuario) }
      )
      .subscribe((data) => {
        this.pexipdata = data;
      });
  }

  //////CÁMARA/////

  changeCamera() {
    if (!this.camaras.length) {
      return;
    }

    this.n = (this.n + 1) % this.camaras.length; // Incrementa y reinicia al inicio si se excede el límite
    this.videoMedias().then(() => {
      this.selectAvailableCamera();
    });
    this.apagado = false;
    localStorage.setItem('apagado', 'false');
  }
  async videoMedias() {
    const stream = await window.navigator.mediaDevices
      .enumerateDevices()
      .then((videoMedia) => {
        const todos = [];
        const camaraList = [];
        videoMedia.forEach((video) => {
          const type = video.kind;
          todos.push(video);
          if (type === 'videoinput') {
            camaraList.push(video);
          }
        });
        this.camaras = camaraList;
      });
  }
  async selectCamera(id) {
    try {
      if (!id) {
        throw new Error('El ID de cámara no es válido.');
      }

      const constraints = {
        video: { deviceId: { exact: id }, width: { ideal: 1080 } },
      };

      const mediastream = await window.navigator.mediaDevices.getUserMedia(
        constraints
      );

      localStorage.setItem('deviceId', id);
      this.apagado = false;
      localStorage.setItem('apagado', 'false');

      const videoElement = document.querySelector('video');
      if (videoElement) {
        videoElement.srcObject = mediastream;
        videoElement.play();
      } else {
        throw new Error('Elemento de video no encontrado en el DOM.');
      }

      console.log('Cámara cambiada exitosamente:', id);
    } catch (err) {
      console.error('Error al seleccionar la cámara:', err.message);
    }
  }

  private selectAvailableCamera(preferredId?: string) {
    if (!this.camaras.length) {
      return;
    }

    const selectedCamera =
      this.camaras.find((camera) => camera.deviceId === preferredId) ||
      this.camaras[this.n] ||
      this.camaras[0];

    if (!selectedCamera?.deviceId) {
      return;
    }

    this.deviceId = selectedCamera.deviceId;
    this.cambiarNdeCamara(selectedCamera.deviceId);
    this.selectCamera(selectedCamera.deviceId);
  }

  async apagar() {
    this.eleccion();
  }
  eleccion() {
    console.log('apagadin' + this.apagado);
    if (this.apagado == true) {
      this.encenderCamara().then(() => {
        this.apagado = false;
        localStorage.setItem('apagado', 'false');
      });
    } else {
      this.apagarCamara().then(() => {
        this.apagado = true;
        localStorage.setItem('apagado', 'true');
      });
    }
  }

  async apagarCamara() {
    var constraints = {
      video: true,
      audio: true,
      // width: { ideal: 2160 },
    };
    console.log('encendido');
    await window.navigator.mediaDevices
      .getUserMedia(constraints)
      .then((mediastream) => {
        this.apagado = true;
        document.querySelector('video').srcObject = mediastream;
        const tracks = mediastream.getTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
      });
  }
  async encenderCamara() {
    console.log('videos');
    await this.videoMedias().then(() => {
      // this.apagado=false;
      if (!this.deviceId || this.deviceId == undefined) {
        this.deviceId = this.camaras[this.n]?.deviceId;
      }

      return this.selectAvailableCamera(this.deviceId);
    });
  }

  ///  BUSCAR USUARIOS   ///
  search() {
    // if(this.clases.includes("0MYFZ2lrZKZ69JjARsVB")){
    //   return
    // }
    // if(this.clases.includes("0MYFrkjV4l2THtX6CLGZ")){
    //   return
    // }

    var clases = [];
    this.clases.forEach((clase) => {
      if (!this.clasesCapadas.includes(clase)) {
        clases.push(clase);
      }
    });

    this.userService.searchUsers(clases).subscribe((searchdata) => {
      this.results = searchdata;
    });
  }

  openVideo(usuario) {
    window.open(
      'https://access.colegia.education/webapp3/#/?conference=' +
        usuario.usuario +
        '&name=' +
        this.getUserName(this.userdata) +
        ' ' +
        this.getUserLastName(this.userdata) +
        '&role=guest&callType=video&join=1'
    );
  }

  popProfesores() {
    this.profesoresPop = !this.profesoresPop;
  }

  irMagisterio() {
    this.loading = true;
    const tiempoMagisterio = moment().tz('Europe/Madrid').toDate();
    // Convertir a Timestamp si usas Firestore
    // @ts-ignore
    console.log('tiempoMagisterio', tiempoMagisterio);

    console.log('id', this.id);

    const codigoMagisterio = Array.from({ length: 16 }, () =>
      Math.random().toString(36).charAt(2)
    )
      .join('')
      .toUpperCase();
    console.log('codigoMagisterio', codigoMagisterio);

    // const magisterioInfo = {
    //   tiempoMagisterio: tiempoMagisterio,
    //   codigoMagisterio: codigoMagisterio,
    // };

    this.userService
      .editUser({ tiempoMagisterio, codigoMagisterio }, this.id)
      .then(() => {
        this.http
          .get<any>(
            'https://us-central1-the-campus-56b06.cloudfunctions.net/app/tokenMagisnet',
            { params: new HttpParams().set('codigo', codigoMagisterio) }
          )
          .subscribe((data) => {
            this.loading = false;
            if (data == 'error') {
              alert(
                'Error al intentar ingresar en la página. Por favor, inténtalo de nuevo más tarde.'
              );
              return;
            }
            console.log('token', data);
            const token = data;
            window.open(
              `https://www.magisnet.com/wp-json/magisnet-sso-for-the-campus/v1/login?token=${token}`
            );
          });
      });
  }

  // async selectAudio(id) {
  //   var constraints = { deviceId: id, audio: true };
  //   const audio = await window.navigator.mediaDevices
  //     .getUserMedia({ audio: constraints })
  //     .then((mediastream) => {
  //       const tracks = mediastream.getAudioTracks();
  //     });
  // }
}

